import { FiX } from 'react-icons/fi';
import './Tag.styles.css';

const Tag = ({
  id,
  title,
  onDelete,
}: {
  id: number | string;
  title: string;
  onDelete: (id: number | string) => void;
}) => {
  const handleDelete = () => {
    onDelete(id);
  };
  return (
    <div className="tag">
      <span>{title}</span>
      <FiX onClick={handleDelete} style={{ cursor: 'pointer' }} />
    </div>
  );
};

export default Tag;
